import { FetchUtil } from "../util/FetchUtil";
import { IExpiringActivityModel } from "../models/NotificationBox/IExpiringActivityModel";
import { INotificationBoxServiceEndpoint } from "../models/NotificationBox/INotificationBoxServiceEndpoint";
import { StringUtil } from "../util/StringUtil";
import { INotificationBoxLoadResponse } from "../models/NotificationBox/INotificationBoxLoadResponse";

export class NotificationBoxService {
  private _expiringActivityPromise: Promise<IExpiringActivityModel[] | null> | null = null;
  constructor(private readonly _endpoint: INotificationBoxServiceEndpoint) {
  }

  public async getExpiringActivities(): Promise<IExpiringActivityModel[] | null> {
    const cachedPromise = this._expiringActivityPromise;

    return cachedPromise || (this._expiringActivityPromise = this.load());
  }

  private async load(): Promise<IExpiringActivityModel[] | null> {
    const endpoint = this._endpoint.load;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    const result = await FetchUtil
      .sendMessage(endpoint);

    const response = result as INotificationBoxLoadResponse;

    return response.activities;
  }

  public async deleteNotification(activityId: string): Promise<boolean> {
    const endpoint = this._endpoint.deleteNotification;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    const values = {
      activityId: activityId
    };

    const url = StringUtil.supplant(endpoint.url, values) || "";

    const result = await FetchUtil
      .sendMessage({ method: endpoint.method, url });

    const response = result as {data: boolean};

    return response.data;
  }

  public async updateNotificationSettings(hideNotifications: boolean): Promise<boolean> {
    const endpoint = this._endpoint.updateSettings;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const body = {
      hideNotifications: hideNotifications
    };

    const result = await FetchUtil
      .sendMessage(endpoint, body);

    const response = result as {data: boolean};

    return response.data;
  }
}
